import React, { Fragment, useState } from "react";
import AntTable from "../../common/Table";  
import { compose, graphql } from 'react-apollo';
import { removeBranchM } from "../../../graphql/mutation/branch";
import columns from "../../../const/columns/branch";
import routes from "../../../const/routes";
import RefreshButton from "../../common/RefreshButton";
import { openNotificationWithIcon } from "../../common/Notification";
import { Spin } from "antd";

function Branch({props, removeBranch}){
    let [ loading, setLoading ] = useState(false); 

    async function deleteF(id){
        let body = {
            _id: id,
            removeBranch 
        };
    
        await props.REMOVE_BRANCH(body);

        setTimeout(() => {props.refetch()},10)
        openNotificationWithIcon('success', "Sucesso", "Filial deletada com sucesso", "", 7);
    }

    function update(id){
        localStorage.setItem('@Ossel:Update', true);
        localStorage.setItem('@Ossel:UpdateID', id);
    }

    function refresh(){
        setLoading(loading = true);
        setTimeout(() => {
            setLoading(loading = false);
            props.refetch();
        }, 1000);
    }
 
    return(
        <Fragment>
            <RefreshButton clickAction={refresh}/>
            <Spin spinning={loading}>
                <AntTable 
                    dataSource={props.branchs ? props.branchs : []} 
                    columns={columns} 
                    new={routes.BRANCHS_FORM} 
                    delete={deleteF} 
                    update={update}
                    btEdit={true}
                    btDelete={true}
                />
            </Spin>
        </Fragment>
    )
}

export default compose(
    graphql( removeBranchM, { name: "removeBranch" } )
)(Branch);


// WEBPACK FOOTER //
// ./src/components/general/branchWrapper/Branch.jsx